import React, { useState, useEffect, useCallback } from 'react';
import IndiaPopup from './IndiaPopup';
import SouthKoreaPopup from './SouthKoreaPopup';

const CountryPopup = () => {
	const [showIndiaPopup, setShowIndiaPopup] = useState(false);
	const [showSouthKoreaPopup, setShowSouthKoreaPopup] = useState(false);
	const [countryChecked, setCountryChecked] = useState(false);
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		// Added this to avoid hydration error
		setIsClient(true);
	}, []);

	const handleCountryDetection = useCallback((country) => {
		// Check if user hasn't already seen the popup (using sessionStorage)
		const countryKey = country.replace(/\s+/g, '_');
		const hasSeenPopup = sessionStorage.getItem(`popup_shown_${countryKey}`);

		if (!hasSeenPopup) {
			if (country === 'India') {
				setShowIndiaPopup(true);
				sessionStorage.setItem('popup_shown_India', 'true');
			} else if (country === 'South Korea') {
				setShowSouthKoreaPopup(true);
				sessionStorage.setItem('popup_shown_South_Korea', 'true');
			}
		}
	}, []);

	const handleCountryLocationSuccess = useCallback((event) => {
		if (event.detail?.location?.country) {
			const country = event.detail.location.country;
			handleCountryDetection(country);
		}
		setCountryChecked(true);
	}, [handleCountryDetection]);

	const handleCountryLocationFail = useCallback(() => {
		setCountryChecked(true);
	}, []);

	useEffect(() => {
		if (!isClient) return;

		const fetchLocationData = async () => {
			try {
				if (window.sessionLayer?.marketingService?.getData) {
					const data = await window.sessionLayer.marketingService.getData();
					const successEvent = new CustomEvent('countryLocationSuccess', {
						detail: data
					});
					document.dispatchEvent(successEvent);
				} else {
					document.dispatchEvent(new CustomEvent('countryLocationFail'));
				}
			} catch (error) {
				console.error('CountryPopup: Error fetching location data:', error);
				document.dispatchEvent(new CustomEvent('countryLocationFail'));
			}
		};

		document.addEventListener('countryLocationSuccess', handleCountryLocationSuccess);
		document.addEventListener('countryLocationFail', handleCountryLocationFail);

		fetchLocationData();

		return () => {
			document.removeEventListener('countryLocationSuccess', handleCountryLocationSuccess);
			document.removeEventListener('countryLocationFail', handleCountryLocationFail);
		};
	}, [isClient, handleCountryLocationSuccess, handleCountryLocationFail]);

	const handleCloseIndiaPopup = () => {
		setShowIndiaPopup(false);
	};

	const handleCloseSouthKoreaPopup = () => {
		setShowSouthKoreaPopup(false);
	};

	// Don't render anything until we're on the client side and have checked the country
	if (!isClient || !countryChecked) {
		return null;
	}

	return (
		<>
			<IndiaPopup isVisible={showIndiaPopup} onClose={handleCloseIndiaPopup} />
			<SouthKoreaPopup isVisible={showSouthKoreaPopup} onClose={handleCloseSouthKoreaPopup} />
		</>
	);
};

export default CountryPopup;
